import { useState } from "react";
import { ExternalLink, Maximize2, Minimize2 } from "lucide-react";
import { clsx } from "clsx";

interface DashboardEmbedProps {
  grafanaUrl?: string;
  dashboardUid?: string;
  tenantId?: string;
}

export function DashboardEmbed({
  grafanaUrl = "/grafana-proxy",
  dashboardUid = "alphaprox-cluster-overview",
  tenantId,
}: DashboardEmbedProps) {
  const [isFullscreen, setIsFullscreen] = useState(false);

  const params = new URLSearchParams({
    orgId: "1",
    kiosk: "tv",
    theme: "dark",
  });

  if (tenantId) {
    params.set("var-tenant", tenantId);
  }

  const embedUrl = `${grafanaUrl}/d/${dashboardUid}?${params.toString()}`;

  return (
    <div
      className={clsx(
        "flex flex-col overflow-hidden rounded-xl border border-gray-800",
        isFullscreen && "fixed inset-0 z-50 rounded-none border-none"
      )}
    >
      {/* Header */}
      <div className="flex items-center justify-between border-b border-gray-800 bg-gray-900 px-4 py-2">
        <h3 className="text-sm font-medium text-gray-300">
          Grafana Dashboard
        </h3>
        <div className="flex items-center gap-2">
          <a
            href={embedUrl.replace("kiosk=tv", "kiosk=")}
            target="_blank"
            rel="noopener noreferrer"
            className="rounded p-1 text-gray-400 transition-colors hover:bg-gray-800 hover:text-gray-200"
            title="Open in Grafana"
          >
            <ExternalLink className="h-4 w-4" />
          </a>
          <button
            onClick={() => setIsFullscreen(!isFullscreen)}
            className="rounded p-1 text-gray-400 transition-colors hover:bg-gray-800 hover:text-gray-200"
            title={isFullscreen ? "Exit fullscreen" : "Fullscreen"}
          >
            {isFullscreen ? (
              <Minimize2 className="h-4 w-4" />
            ) : (
              <Maximize2 className="h-4 w-4" />
            )}
          </button>
        </div>
      </div>

      {/* Iframe */}
      <div className={clsx("bg-gray-950", isFullscreen ? "flex-1" : "h-[600px]")}>
        <iframe
          src={embedUrl}
          title="Grafana Dashboard"
          className="h-full w-full border-none"
          sandbox="allow-same-origin allow-scripts allow-popups"
        />
      </div>
    </div>
  );
}
